export default function($) {

  function order_line_handle_success(product_id, variation_id) {
    $('#add-to-cart-product-'+product_id).siblings('.js-added-to-cart').removeClass('hidden');
    $('#add-to-cart-variable-product-'+variation_id).siblings('.js-added-to-cart').removeClass('hidden');

    $('#variation-quantity-'+variation_id).val(0)
    $('#variation-quantity-'+variation_id).addClass('bg-green-500')
    setTimeout(function(){
      $('#variation-quantity-'+variation_id).removeClass('bg-green-500')
    }, 750);
  }

  function refresh_wc_cart_and_notices() {
    // We force refresh woocommerce mini-cart fragments using
    // WooCommerce native event 'wc_fragment_refresh'
    $( document.body ).trigger( 'wc_fragment_refresh' );

    // refresh wc notices
    if ($('.js-wc-notices-fragments').length > 0) {
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          "action" : "client-refresh-wc-notice", // from CLIENT_WC_Notice_Hooks
        },
        type: "GET"
      })
      .done(function(response) {
        let content = JSON.parse(response).content

        $('.js-wc-notices-fragments').html(content)
        if (content.length > 0) {
          $(window).scrollTop(0)
        }
      })
    }
  }

  function add_to_cart(quantity, product_id, variation_id=0) {
    if (quantity > 0) {
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          "action" : "woocommerce_add_variations_to_cart", // from ImagileWooCommerce plugin
          "variations" : [{
            "product_id" : product_id,
            "variation_id" : variation_id,
            "quantity" : quantity,
          }],
        },
        type: "POST"
      })
      .done(function() {
        order_line_handle_success(product_id, variation_id)
        refresh_wc_cart_and_notices()
      })
    }
  }

  // ---------------------
  // Variation add to cart
  // ---------------------
  var add_variation_to_cart_buttons = $('.js-product-variation-add-to-cart');

  // we do nothing if the selector is not found
  if ( add_variation_to_cart_buttons.length > 0 ) {
    add_variation_to_cart_buttons.each(function () {
      $(this).click(function(event) {
        event.preventDefault()

        var quantity_input = $(this).closest('.js-product-variation').find('.js-variation-quantity')

        var quantity = quantity_input.val();
        var product_id = quantity_input.data('product-id')
        var variation_id = quantity_input.data('variation-id')

        if (validateQuantity(quantity_input)) {
          add_to_cart( quantity, product_id, variation_id )
        }
      })
    })
  }
  // ---------------------


  // ---------------------
  // Product add to cart
  // ---------------------
  var add_product_to_cart_buttons = $('.js-product-add-to-cart');

  // we do nothing if the selector is not found
  if ( add_product_to_cart_buttons.length > 0 ) {
    add_product_to_cart_buttons.each(function () {
      $(this).click(function(event) {
        event.preventDefault()

        var quantity_input = $(this).closest('.js-product').find('.js-product-quantity')

        if (quantity_input.length == 0) {
          var quantity = 1; // direct link with no quantity
        } else {
          var quantity = quantity_input.val();
        }

        var product_id = $(this).data('product-id')

        add_to_cart( quantity, product_id )
      })
    })
  }
  // ---------------------

  //
  // Global add to cart
  //
  var global_add_to_cart_button = $('.js-global-add-to-cart');
  if (global_add_to_cart_button.length > 0) {
    global_add_to_cart_button.click(function(event) {
      event.preventDefault()

      var variations = []
      $.each(
        $(this).closest('table').find('.js-product-variation'),
        function(index, value) {
          let quantityNode = $(value).find('.js-variation-quantity')
          let quantity = parseInt(Number( quantityNode.val() ))
          if (isNaN(quantity) || quantity <= 0) {
            return; // this is equivalent of 'continue' for jQuery loop
          }

          if (validateQuantity(quantityNode)) {
            variations.push({
              "product_id" : quantityNode.data('product-id'),
              "variation_id" : quantityNode.data('variation-id'),
              "quantity" : quantity,
            })
          }
        }
      )

      if (variations.length > 0) {
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            "action" : "woocommerce_add_variations_to_cart", // from ImagileWooCommerce plugin
            "variations" : variations,
          },
          type: "POST"
        })
        .done(function() {
          $.each(variations, function(index, value) {
            let product_id = value.product_id
            let variation_id = value.variation_id
            order_line_handle_success(product_id, variation_id)
          })
          refresh_wc_cart_and_notices()
        })
      }
    });
  }

  // ----------

  //
  // Fast Checkout
  //

  var fast_checkout_buttons = $('.js-fast-checkout-trigger');
  if (fast_checkout_buttons.length > 0) {
    fast_checkout_buttons.click(function(event) {
      event.preventDefault()

      var value_fast_checkout = $(this).closest('section').find('.js-fast-checkout-input').val();
      if (isNaN(value_fast_checkout) || value_fast_checkout <= 0) {
        return;
      }

      $.each(
        $(this).closest('section').find('.js-product-variation'),
        function(index, value) {
          let quantityNode = $(value).find('.js-variation-quantity');
          quantityNode.val(value_fast_checkout);
        }
      );
    });
  }

  // ----------

  //
  // Quantity validations
  //
  function validateQuantity($VariationNode) {
    var qty_selected = parseInt(Number( $VariationNode.val() ))
    var variation_id = $VariationNode.data('variation-id')
    var qty_step = parseInt($VariationNode.attr('min'))
    var qty_min = parseInt($VariationNode.attr('step'))

    if (Number.isInteger(qty_min) && qty_selected < qty_min && qty_min > 0) {
      $VariationNode.after("<div id=\"validation_error_"+variation_id+"\" class=\"text-red-800\">The selected quantity must be greater than " + qty_step + "</div>")
      return false
    }
    if (Number.isInteger(qty_step) && (qty_selected % qty_step !== 0) && qty_step > 1) {
      $VariationNode.after("<div id=\"validation_error_"+variation_id+"\" class=\"text-red-800\">The quantity have to be a multiple of " + qty_step + "</div>")
      return false
    }
    $VariationNode.next("#validation_error_"+variation_id).remove()
    return true
  }
}
